import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import formatDate from 'date-fns/format';
import { parse } from 'date-fns';

import store from '../store';
import MobileSidebarCard from './MobileSidebarCard';
import SeverityDescription from './SeverityDescription';
import Tooltip from './Tooltip';
import RecommendedVaccine from './RecommendedVaccine';
import SkyscannerBanner from './SkyscannerBanner';
import Disclaimer from './Disclaimer';

const stringToBR = (str) => {
	return str.split('\\n').map((x, i) => {
		return (
			<Fragment key={i}>
				{x}
				<br />
			</Fragment>
		);
	});
};

class Single extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			singleScrollCls: '',
		};
	}

	componentDidMount() {
		if (this.singleScroller) {
			this.singleScroller.addEventListener('scroll', this.handleScroll);
		}
	}

	componentWillUnmount() {
		if (this.singleScroller) {
			this.singleScroller.removeEventListener('scroll', this.handleScroll);
		}
	}

	handleBackClick(event) {
		// prevent link/back click from triggering mobile card open
		event.stopPropagation();
		store.dispatch(push('/travel'));
	}

	handleScroll = () => {
		if (this.singleScroller.scrollTop > 0) {
			this.setState({
				singleScrollCls: 'is-scrolled',
			});
		} else {
			this.setState({
				singleScrollCls: '',
			});
		}
	};

	renderCountry(country) {
		const headerStyle = country.image ? { backgroundImage: `url(${country.image})` } : null;
		const hasAdvice = country.advice_all || country.traveller_advice;
		return (
			<div className="single-container">
				<MobileSidebarCard
					noCover={true}
					disableFooterClose={true}
					ref={(MobileSidebarCard) => {
						this.MobileSidebarCard = MobileSidebarCard;
					}}
				>
					<div className={`single-mobile-bar ${this.state.singleScrollCls}`}>
						<div className="single-mobile-bar-country">{country.name}</div>
						<div className="single-mobile-bar-close" onClick={(event) => this.handleBackClick(event)} />
					</div>

					<div
						ref={(singleScroller) => {
							this.singleScroller = singleScroller;
						}}
						className={`single ${country.image ? 'is-featured' : ''}`}
					>
						<div className="single-header" style={headerStyle}>
							<div onClick={(event) => this.handleBackClick(event)} className="single-header-back-btn arrow-link">
								<div className="arrow arrow-left" />
								Back to top destinations
							</div>
							<h1 className="priority-1">{country.name}</h1>
						</div>

						<div className={`sidebar-section ${country.description ? 'has-description' : 'no-description'}`}>
							<div className="single-content">
								{country.description && (
									<div className={`single-description level-${country.level}`}>
										<div className="single-description-title">
											<SeverityDescription level={country.level} />
										</div>
										{country.description ? (
											<div
												dangerouslySetInnerHTML={{
													__html: country.description
														.replace(/\\u00a0/gi, '')
														// Make all relative links absolute to smartraveller base url
														.replace(
															/href=('|")\//g,
															'data-lightbox="leavesite" target="_blank" rel="noopener noreferrer" href=$1https://www.smartraveller.gov.au/'
														),
												}}
											></div>
										) : null}
										<div className="single-updated-date">
											<Tooltip align="left" scrollContainer={this.singleScroller}>
												This official travel advice is taken from the Smartraveller.gov.au website. For the latest and
												most complete information, please visit{' '}
												<a
													href="https://Smartraveller.gov.au"
													target="_blank"
													rel="noopener noreferrer"
													data-lightbox="leavesite"
												>
													Smartraveller.gov.au
												</a>
											</Tooltip>
											<div className="single-updated-date__content">
												Travel advice by Smartraveller. <br />
												Last updated on{' '}
												{formatDate(parse(country.st_updated_date, 'yyyy-MM-dd', new Date()), 'do MMMM yyyy')}
											</div>
										</div>
									</div>
								)}
								{hasAdvice && (
									<div className="recommended-vaccines">
										<div className="recommended-vaccines-title">
											The following diseases are prevalent in {country.name} and you should prepare your patients by
											discussing preventative measures they can take prior to and during their travel.
										</div>
										{country.advice_all && (
											<Fragment>
												<div className="recommended-vaccines-title">Advice for travellers</div>
												<p>{stringToBR(country.advice_all)}</p>
											</Fragment>
										)}
										{country.traveller_advice && (
											<div className="recommended-vaccines">
												{country.traveller_advice.map((vaccine, index) => (
													<RecommendedVaccine key={index} vaccine={vaccine} country={country} />
												))}
											</div>
										)}
									</div>
								)}
								<div
									className={`find-a-doctor single-section${
										!country.hasOwnProperty('topDestination') ? ' no-border' : ''
									}`}
								>
									<div className="find-a-doctor-inner">
										<p>
											Vaccine Hub offers general information only. Please see a healthcare professional for medical
											advice.
										</p>
									</div>
								</div>
								{window.vaxihub && country.hasOwnProperty('topDestination') && (
									<div className="single-learn-more">
										<a href={country.url} target="_blank" className="arrow-link">
											Find out more about staying healthy in {country.name}
											<div className="arrow arrow-right" />
										</a>
									</div>
								)}
							</div>
						</div>
						<Disclaimer country={country} />
					</div>
				</MobileSidebarCard>
			</div>
		);
	}

	render() {
		if (this.props.data) {
			const country = this.props.data.filter((c) => {
				if (c.ISO) {
					return c.ISO.toLowerCase() === this.props.match.params.country;
				}
			});
			if (!country.length) {
				return (
					<div className="single-container">
						<div className="single">
							<Link to="/travel">Back to Travel</Link>
							<p>Error: Country doesnt exist</p>
						</div>
					</div>
				);
			}
			return this.renderCountry(country[0]);
		}
		return null;
	}
}

function mapStateToProps(state) {
	return {
		data: state.json.data.travel,
	};
}

export default connect(mapStateToProps)(Single);
